<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .Stadium{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:bottom;
    width: 100%;
    overflow: hidden;
  }
  .Stadium .nav{
    background:url('../assets/img/navbg.png')no-repeat;
    width: 1530px;
    height: 110px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .Stadium .nav img{
    float: left;
    margin-left: 160px;
    margin-top: 35px;
  }
  .Stadium .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .Stadium .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 120px;
    text-align: center;
    line-height: 110px;
    color: #ebbfbf;
    font-size: 16px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
  }
  .Stadium .nav ul li span{
    position: absolute;
    left: 0;
    bottom: -25px;
    text-align: center;
    width: 100%;
    font-weight: 100;
  }
  .Stadium .nav ul li:hover{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .Stadium .nav ul li.on{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .Stadium .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .Stadium .content {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 195px;
    overflow: hidden;
  }
  .Stadium .content .title{
    margin-top: 100px;
    color: #ffffff;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .Stadium .content .title img{
    margin-right: 15px;
  }
  .Stadium .content .text1{
    min-height: 300px;
  }
  .Stadium .content .text1 ul{
    overflow: hidden;
    width: 300px;
    margin: 0 auto;
  }
  .Stadium .content .text1 ul li {
    float: left;
    width: 250px;
  }
  .Stadium .content .text1 ul li img{
    width: 100%;
  }

  .Stadium .content .mp1{
    width: 580px;
    float: left;
  }
  .Stadium .content .mp2{
    width: 580px;
    float: right;
  }
  .Stadium .content .map img{
    width: 100%;
  }
  .Stadium .content .map p {
    color: #ffffff;
    margin: 10px 0;
  }
</style>
<template>
  <div class="Stadium">
    <myhead></myhead>
    <nav class="nav">
      <img src="../assets/img/logo.png" alt=""/>
      <ul>
        <li @click="urlFun('/Home')"> 首页 <span>Home</span></li>
        <li @click="urlFun('/news')">新闻<span> News</span></li>
        <li @click="urlFun('/rules')">规则<span> Rule</span></li>
        <li @click="urlFun('/match')">赛程<span>Schedule</span></li>
        <!--<li @click="urlFun('/videoList')">视频<span>Video</span></li>-->
        <li class="on" @click="urlFun('/videoList')">场馆<span>Venue</span></li>
        <li @click="urlFun('/live')">直播<span> Live</span></li>
      </ul>
      <div class="btn" @click="urlFun('/signUp')"></div>
    </nav>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>比赛场馆/Competition venues</div>
      <div style="overflow: hidden;">
        <div class="map mp1">
          <iframe src="http://www.google.cn/maps/embed?pb=!1m18!1m12!1m3!1d3408.4625689012537!2d121.48284531565263!3d31.31859598143671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2724e8505a4e9%3A0x26fa00917fbd1e09!2z5LiK5rW35biC5a6d5bGx5Yy65LqU6KeS5Zy66YC45LuZ6LevMTMyOOWPtyDpgq7mlL_nvJbnoIE6IDIwMDA2NQ!5e0!3m2!1szh-CN!2scn!4v1566195582192!5m2!1szh-CN!2scn" width="580" height="440" frameborder="0" style="border:0" allowfullscreen></iframe>
          <p>比赛地点：上海市逸仙路1328号 新业坊·源创全球科创示范区</p>
          <br/>
          <p>线路1:上海虹桥国际机场 -> 地铁2号线 → 地铁3号线 ->场馆</p>
          <br/>
          <p>线路2:上海浦东国际机场 -> 地铁2号线 → 地铁4号线 → 地铁3号线  -> 场馆</p>
        </div>
        <div class="map mp2">
          <iframe src="http://www.google.cn/maps/embed?pb=!1m18!1m12!1m3!1d3408.462568901253!2d121.48284531514557!3d31.318595981436744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2724e8505a4e9%3A0x26fa00917fbd1e09!2s1328+Yixian+Rd%2C+Wu+Jiao+Chang%2C+Baoshan+Qu%2C+Shanghai+Shi%2C+200065!5e0!3m2!1sen!2scn!4v1566195693900!5m2!1sen!2scn" width="580" height="440" frameborder="0" style="border:0" allowfullscreen></iframe>
          <p> No. 1328, Yixian Road, Shanghai, Xinye Fang·Yuanchuang Global Science and Technology Demonstration Zone</p>
          <br/>
          <p>Shanghai Hongqiao International Airport -> Metro Line 2 → Metro Line 3 -> Venue</p>
          <br/>
          <p>Shanghai Pudong International Airport -> Metro Line 2 →  Metro Line 4 →  Metro Line 3 -> Venue</p>
        </div>
      </div>
      <div style="color: #ffffff;margin-bottom: 40px">
        <div class="title"><img src="../assets/img/title.png" alt=""/>酒店推荐/Recommended hotels</div>
        <p>酒店推荐：上海虹口大柏树亚朵酒店，地址：上海曲阳路1000号。距离活动场地约3公里，电话021-55979999全季酒店(上海新江湾城殷高路店) 上海市宝山区高境镇殷高路65号 (021)55895799</p>
        <br/>
        <p> Recommended hotels：Atour Hotel (Shanghai Hongkou Dabaishu) reserve：400 862 8088 (CouponCode:74287) Business zone: Wujiaochang Business District (江湾/五角场商业区)Area: hongkouqu (虹口区)Address: QuYang road 1000, Hongkou District, Shanghai, China</p>
      </div>
    </div>
    <mybottom></mybottom>
  </div>
</template>
<script type="text/javascript" src=""></script>
<script>
  import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  export default {
    name: 'Rules',
    components: {
      mybottom,
      myhead
    },
    data () {
    return {
    }
  },

  computed:{

  },
  mounted(){
  },
  methods:{
    urlFun(url){
      this.$router.push({path:url})
    },

  },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/stadium.vue